import { ELocale } from '@zennolab_platform/webui-sdk/dist/stores/IntlStore';

/** UA2 or browser language tag (UA2 may pass a full tag such as en-US) → app locale; else none. */
export const asLocale = (tag?: string | null): ELocale | undefined => {
  const lang = tag?.toLowerCase().split('-')[0];
  return Object.values(ELocale).find(locale => locale === lang);
};

/** UA2's ?lang, else the language UA2 gave earlier in this session (the URL loses it after a login redirect), else the browser's, else Russian. */
export function pickLocale(search: string, browserLanguage: string, remembered?: string | null): ELocale {
  return (
    asLocale(new URLSearchParams(search).get('lang')) ?? asLocale(remembered) ?? asLocale(browserLanguage) ?? ELocale.RU
  );
}

const LOCALE_KEY = 'zbAdmin.lang';

/** Keeps a language UA2 switched to, for later loads without ?lang. */
export function rememberLocale(locale: ELocale): void {
  try {
    sessionStorage.setItem(LOCALE_KEY, locale);
  } catch {
    // Storage blocked (third-party frame): the URL and the browser decide.
  }
}

/** pickLocale over the session storage: a ?lang from UA2 is kept for later loads without it. */
export function sessionLocale(search: string, browserLanguage: string): ELocale {
  let remembered: string | null = null;
  try {
    remembered = sessionStorage.getItem(LOCALE_KEY);
  } catch {
    // Storage blocked (third-party frame): the URL and the browser decide.
  }
  const locale = pickLocale(search, browserLanguage, remembered);
  if (asLocale(new URLSearchParams(search).get('lang'))) rememberLocale(locale);
  return locale;
}
